import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_CORRECTION_REQUESTS_KEY } from '@/keys';
import type {
  CorrectionRequest,
  CorrectionRequestEntityType,
} from '@/types/core/purchase-order/correction-request';

type GetProductionDeclarationCorrectionRequestsParams = {
  commodityOriginId: string;
  entityType: CorrectionRequestEntityType;
  materialId: string;
  productionDeclarationId: string;
  token?: string;
};

export function getProductionDeclarationCorrectionRequestsQueryKey({
  commodityOriginId,
  entityType,
  materialId,
  productionDeclarationId,
  token,
}: GetProductionDeclarationCorrectionRequestsParams) {
  return [
    ...GET_PRODUCTION_DECLARATION_CORRECTION_REQUESTS_KEY,
    productionDeclarationId,
    materialId,
    commodityOriginId,
    entityType,
    token ?? '',
  ];
}

async function getProductionDeclarationCorrectionRequests({
  commodityOriginId,
  entityType,
  materialId,
  productionDeclarationId,
  token,
}: GetProductionDeclarationCorrectionRequestsParams): Promise<
  CorrectionRequest[]
> {
  const response = await api.get<CorrectionRequest[]>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/correction-requests`,
    {
      params: {
        entityType,
        token,
      },
    },
  );

  return response.data;
}

export function useGetProductionDeclarationCorrectionRequests(
  params: GetProductionDeclarationCorrectionRequestsParams & {
    enabled?: boolean;
  },
): UseQueryResult<CorrectionRequest[], Error> {
  return useQuery({
    queryKey: getProductionDeclarationCorrectionRequestsQueryKey(params),
    queryFn: async () =>
      await getProductionDeclarationCorrectionRequests(params),
    enabled: Boolean(
      params.enabled &&
        params.productionDeclarationId &&
        params.materialId &&
        params.commodityOriginId,
    ),
  });
}
